export enum ShowStatus {
  /** 后台已绑卡，待绑定 */
  NotActivated = 1,
  /** 激活中 */
  Activating = 2,
  /** 激活失败审核失败 */
  ActivationFailed = 3,
  /** 已锁卡 */
  Locked = 4,
  /** 正常使用 */
  Success = 5,
  /** 继续开卡状态 */
  Submitting = 6,
  /** 绑定在用户身上，需要激活 */
  BindNotActivated = 7,
  /** 销卡 */
  Canceled = 8,
  /** 注销中 */
  Canceling = 9,
  /** Pin错误引起锁卡 */
  PinLock = 10,
}
export enum VendorCardType {
  /** 卡片 */
  Card = 'card',
  /** 附属卡 */
  SubCard = 'subCard',
}
/** release_type 卡片类型 */
export enum CardType {
  /** 虚拟卡 */
  Virtual = 1,
  /** 实体卡 */
  Entity = 2,
}
/** use_status 卡片是否可以申请 */
export enum ApplyType {
  /**  可以申请 */
  Enable = -1,
  /** 不可以申请 */
  Disable = 1,
}
/** balance_type 卡片类型 */
export enum BalanceType {
  /** 余额卡 */
  Share = 2,
  /** 储蓄卡 */
  Saving = 1,
}
